import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import {
  filterValuesAtom,
  paginationConfigAtom,
  selectedRowIdsAtom,
} from './IntegrationListing/state';
import {
  appliedIntegrationIdsAtom,
  intervalAtom,
  providerFiltersAtom,
  severityFiltersAtom,
  timeSpanAtom,
} from './state';
import {
  filterValuesAtom as bpaScansFilterValuesAtom,
  paginationConfigAtom as bpaScansPaginationConfigAtom,
  selectedRowIdsAtom as bpaScansSelectedRowIdsAtom,
  orderbyAtom as bpaScansOrderbyAtom,
  sortOrderAtom as bpaScansSortOrderAtom,
} from '../../../Scans/BPAScan/state';

/**
 * Reset all BPA Dashboard atoms when company changes
 */
export function useOnCompanyChangeBPAResetAtoms() {
  const resetTimeSpan = useResetAtom(timeSpanAtom);
  const resetInterval = useResetAtom(intervalAtom);
  const resetAppliedIntegrationIds = useResetAtom(appliedIntegrationIdsAtom);
  const resetSeverityFilters = useResetAtom(severityFiltersAtom);
  const resetProviderFilters = useResetAtom(providerFiltersAtom);

  // Integration Listing atoms
  const resetSelectedRowIds = useResetAtom(selectedRowIdsAtom);
  const resetFilterValues = useResetAtom(filterValuesAtom);
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);

  // BPA Scans atoms
  const resetBpaScansFilterValues = useResetAtom(bpaScansFilterValuesAtom);
  const resetBpaScansSelectedRowIds = useResetAtom(bpaScansSelectedRowIdsAtom);
  const resetBpaScansOrderby = useResetAtom(bpaScansOrderbyAtom);
  const resetBpaScansSortOrder = useResetAtom(bpaScansSortOrderAtom);
  const [bpaScansPaginationConfig, setBpaScansPaginationConfig] = useAtom(
    bpaScansPaginationConfigAtom,
  );

  const resetAtoms = () => {
    // Dashboard atoms
    resetTimeSpan();
    resetInterval();
    resetAppliedIntegrationIds();
    resetSeverityFilters();
    resetProviderFilters();

    // Integration Listing atoms
    resetSelectedRowIds();
    resetFilterValues();
    // Reset page to 1, but preserve page size
    setPaginationConfig({ ...paginationConfig, page: 1 });

    // BPA Scans atoms
    resetBpaScansFilterValues();
    resetBpaScansSelectedRowIds();
    resetBpaScansOrderby();
    resetBpaScansSortOrder();
    setBpaScansPaginationConfig({ ...bpaScansPaginationConfig, page: 1 });
  };

  return resetAtoms;
}
